import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {
  getUserSalaryGroup,
  getUserUniformGroup,
  getUserConsentGroup,
} from '../../services/PermissionGroup';
import { useParams } from 'react-router-dom';
// import { NavigationBar } from "../components/MasterLayout/NavigationBar";
// import { Profile } from "../components/Profile/Profile";

export const Authen = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [success, setSuccess] = useState(false);
  const hostname: string = window.location.pathname;
  const { role }: any = useParams();
  console.log('role=',role);
  useEffect(() => {
    const intervalId = setInterval(() => {
      //assign interval to a variable to clear it.
      if (role === "backoffice") {
        getUserSalaryGroup().then(async (resp: any) => {
          if (resp) {
            window.location.href = '/backoffice';
          }
          setIsAdmin(resp);
          setSuccess(true);
        });
      } else if (role === "uniform") {
        getUserUniformGroup().then(async (resp: any) => {
          if (resp) {
            window.location.href = '/admuniform/uniform-dashboard';
          }
          setIsAdmin(resp);
          setSuccess(true);
        });
      } else if (role === "consent") {
        getUserConsentGroup().then(async (resp: any) => {
          if (resp) {
            window.location.href = '/admconsent/manage-consent';
          }
          setIsAdmin(resp);
          setSuccess(true);
        });
      } else {
        window.location.href = '/';
        setIsAdmin(false);
        setSuccess(true);
      }
    }, 2000);
    return () => clearInterval(intervalId); //This is important
  }, [useState]);
  return (
    <>
      {success && !isAdmin ? (
        <Container>
          <Row>
            <Col>
              <div className="page-denied text-center align-middle">
                <img src="../../../images/locked.png" alt="" />
                <h5 className="mt-3">Permission denied.</h5>
                <p>Your are not autherized to perform this page.</p>
              </div>
            </Col>
          </Row>
        </Container>
      ) : (
        <>
          <div className="loaderpage">
            <div className="loader">
              <div className="spinner"></div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
